import { Drawer } from 'antd';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  position: relative;
  height: 100vh;
  overflow: auto;
  padding: 10px 0;

  .ant-drawer-header {
    display: none;
  }

  .ant-drawer-body {
    padding: 0 30px 10px;
  }
`;

export const GlobalMuteHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0 16px;
  border-bottom: 1px solid #eaeaea;
`;

export const LeftSideHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const RightSideHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled.span<{ clickable?: boolean }>`
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
`;

export const Divider = styled.span`
  display: inline-block;
  width: 1px;
  height: 18px;
  background: #dadada;
  margin: 0 12px;
`;

export const BodyWrapper = styled.div`
  padding-top: 16px;
  max-width: 640px;
`;

export const Description = styled.p`
  margin: 16px 0;
  color: #595959;
  font-size: 13px;
  line-height: 1.5;
`;
